import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { ArrowUpRight, X } from 'lucide-react'

import { buildAndroidAppIntent, hasDriverInvite, isAndroidBrowser, RUSTORE_URL } from '../lib/openInApp'
import './open-in-app-banner.css'

const DISMISS_KEY = 'lupa_open_in_app_dismissed'

function readDismissed(): boolean {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1'
  } catch {
    return false
  }
}

/**
 * "Открыть в приложении" bar above the driver invite page (see lib/openInApp for why it exists).
 * Shown on Android only and only while the page carries an invite; dismissing it lasts for the
 * browser tab, so it does not nag on every reload but comes back for the next link.
 */
export default function OpenInAppBanner() {
  const location = useLocation()
  const [dismissed, setDismissed] = useState(readDismissed)

  if (dismissed) return null
  if (typeof navigator === 'undefined' || !isAndroidBrowser(navigator.userAgent)) return null
  if (!hasDriverInvite(location.search)) return null

  const intentUrl = buildAndroidAppIntent({
    host: window.location.host,
    pathname: location.pathname,
    search: location.search,
  })

  const dismiss = () => {
    setDismissed(true)
    try {
      sessionStorage.setItem(DISMISS_KEY, '1')
    } catch {
      // Private mode — the bar simply comes back on reload.
    }
  }

  return (
    <aside className="open-in-app-banner" aria-label="Открыть заявку в приложении">
      <div className="open-in-app-banner__icon" aria-hidden="true">
        <img src="/pwa-192x192.png" alt="" />
      </div>
      <div className="open-in-app-banner__copy">
        <p>ЛУПА для водителя</p>
        <span>
          Для надёжного отслеживания используйте приложение — оно передаёт геопозицию и в фоне.
        </span>
      </div>
      <div className="open-in-app-banner__actions">
        <a href={RUSTORE_URL} target="_blank" rel="noopener noreferrer" className="open-in-app-banner__action">Скачать в RuStore</a>
        <a
          href={intentUrl}
          className="open-in-app-banner__action"
          aria-label="Открыть заявку в приложении ЛУПА"
        >
          <span>Открыть в приложении</span>
          <ArrowUpRight size={16} aria-hidden="true" />
        </a>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Скрыть предложение открыть приложение"
        className="open-in-app-banner__dismiss"
      >
        <X size={18} aria-hidden="true" />
      </button>
    </aside>
  )
}
